import { Loader2 } from '@/shared/ui/icons';

interface ViewLoaderProps {
  title?: string;
  subtitle?: string;
  fullScreen?: boolean;
}

export function ViewLoader({
  title = 'Loading Quantis',
  subtitle = 'Preparing your workspace',
  fullScreen = false,
}: ViewLoaderProps) {
  return (
    <div
      className={`flex w-full items-center justify-center animate-in fade-in duration-500 ${
        fullScreen ? 'min-h-dvh' : 'h-full min-h-[400px]'
      }`}
      style={{
        background:
          'radial-gradient(circle at top, color-mix(in srgb, var(--primary) 16%, transparent), transparent 44%), var(--canvas)',
      }}
    >
      <div
        className="flex flex-col items-center gap-3 rounded-[28px] px-8 py-7 text-center"
        style={{
          background: 'color-mix(in srgb, var(--surface) 82%, transparent)',
          border: '1px solid color-mix(in srgb, var(--border) 72%, transparent)',
          boxShadow: '0 18px 60px -28px rgba(0, 0, 0, 0.45)',
        }}
      >
        <Loader2 className="h-9 w-9 animate-spin text-primary" />
        <p className="font-apple text-base font-semibold tracking-[0.08em] uppercase text-foreground">
          {title}
        </p>
        <p className="max-w-[280px] font-apple text-sm text-muted-foreground">
          {subtitle}
        </p>
      </div>
    </div>
  );
}

ViewLoader.displayName = 'ViewLoader';
